<template>
  <div>
    <div class="mb-4">
      <div class="h3 fw-bold mb-3">Earn Achievements and Points</div>
      <p>
        As you explore the Canvas course, you will come across clearly marked
        achievement links. Clicking one takes you to a reward page for a
        specific achievement and a chance to earn points.
      </p>
      <p>
        Each achievement is worth a set number of points, which contribute to
        your total score and leaderboard rank.
      </p>

      <p class="mb-2">Depending on the achievement, you will either:</p>

      <ul>
        <li class="mb-2">
          <b>Earn It Instantly</b><br />Some achievements are granted
          immediately when you visit the reward page.
        </li>
        <li>
          <b>Complete a Trivia Challenge</b> <br />
          Others require you to correctly answer trivia questions before the
          achievement is unlocked.
        </li>
      </ul>
    </div>

    <div class="mb-4">
      <div class="h3 fw-bold mb-3">Track your Progress</div>

      <p>
        On the Achievements page, you'll see all achievements: earned, partially
        earned, and locked.
      </p>

      <div class="fs-5 fw-bold mb-1">Earned Achievements</div>
      <p>
        These badges represent achievements you have earned. They appear at the
        top of your list, fully lit and sorted with the most recently earned
        first.
      </p>

      <div class="fs-5 fw-bold mb-1">Partially Earned Achievements</div>
      <p>
        Some achievements require multiple parts to unlock. If you've found one
        or more of the required codes, you will see your progress displayed as a
        fraction on the achievement badge. Keep exploring to collect all parts
        and fully unlock the achievement!
      </p>

      <div class="fs-5 fw-bold mb-1">Locked Achievements</div>
      <p>
        These are achievements you have not earned yet. They appear dimmed to
        show they're still locked. Keep exploring the course to discover how to
        unlock them.
      </p>
    </div>

    <div>
      <div class="h3 fw-bold mb-3">Compete and Collaborate</div>

      <div class="fs-5 fw-bold mb-1">Group Achievements and Points</div>
      <p>
        Each student is placed into a group. Whenever a member earns an
        achievement, the points from that achievement are added to the group's
        total. Your progress contributes not only to your personal score, but to
        your group's score as well.
      </p>

      <div class="fs-5 fw-bold mb-1">Track Personal and Group Progress</div>
      <p>
        Achievements you have unlocked will be clearly marked, and if a group
        member has earned one you have not, their icon will appear on it. This
        way, you can track both your own progress and what your teammates have
        accomplished.
      </p>

      <div class="fs-5 fw-bold mb-1">Climb the Leaderboards</div>
      <p>
        Compete for the top spot! The Leaderboards page features rankings for
        individual and group points, both weekly and all-time. See where you
        stand and aim for the top.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "HowToPlayFAQ"
};
</script>
